import { render, staticRenderFns } from "./TrackRemovalCard.vue?vue&type=template&id=68f75c12&scoped=true&"
import script from "./TrackRemovalCard.vue?vue&type=script&lang=js&"
export * from "./TrackRemovalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f75c12",
  null
  
)

export default component.exports